export const TICKET_EXPORT_IDS_PATH = '/api/exports/tickets/ids';
export const PURCHASE_EXPORT_IDS_PATH = '/api/exports/purchases/ids';

export interface TicketExportFilterInput {
  filterWorkflow: string;
  filterGroup: string;
  filterStatus: string;
  filterPriority: string;
  dateFrom: string;
  dateTo: string;
  searchText: string;
  ticketId: string;
  includeSubtasks: boolean;
}

export interface PurchaseExportFilterInput {
  filterWorkflow: string;
  filterGroup: string;
  filterStatus: string;
  filterPriority: string;
  dateFrom: string;
  dateTo: string;
  searchText: string;
  purchaseRequestId: string;
  includeSubtasks?: boolean;
}

export interface ExportIdListResponse {
  ids: number[];
  total: number;
  subtask_count?: number;
  truncated?: boolean;
}

export function hasTicketExportFilters(input: TicketExportFilterInput): boolean {
  return Boolean(
    input.filterWorkflow ||
      input.filterGroup ||
      input.filterStatus ||
      input.filterPriority ||
      input.dateFrom ||
      input.dateTo ||
      input.searchText ||
      input.ticketId,
  );
}

export function hasPurchaseExportFilters(input: PurchaseExportFilterInput): boolean {
  return Boolean(
    input.filterWorkflow ||
      input.filterGroup ||
      input.filterStatus ||
      input.filterPriority ||
      input.dateFrom ||
      input.dateTo ||
      input.searchText ||
      input.purchaseRequestId,
  );
}

export function buildTicketExportIdParams(
  input: TicketExportFilterInput,
): Record<string, string | number | boolean> {
  const params: Record<string, string | number | boolean> = {
    parent_ticket_id: 0,
  };
  if (input.includeSubtasks) params.include_subtasks = true;
  if (input.filterWorkflow) params.workflow_id = parseInt(input.filterWorkflow, 10);
  if (input.filterGroup) params.assigned_group_id = parseInt(input.filterGroup, 10);
  if (input.filterStatus) params.status = input.filterStatus;
  if (input.filterPriority) params.priority = input.filterPriority;
  if (input.searchText) params.search = input.searchText;
  if (input.ticketId) params.ticket_id = parseInt(input.ticketId, 10);
  if (input.dateFrom) params.created_from = input.dateFrom;
  if (input.dateTo) params.created_to = input.dateTo;
  return params;
}

export function buildPurchaseExportIdParams(
  input: PurchaseExportFilterInput,
): Record<string, string | number | boolean> {
  const params: Record<string, string | number | boolean> = {
    parent_request_id: 0,
  };
  if (input.includeSubtasks) params.include_subtasks = true;
  if (input.filterWorkflow) {
    const workflowId = Number(input.filterWorkflow);
    if (!Number.isNaN(workflowId)) params.workflow_id = workflowId;
  }
  if (input.filterGroup) {
    const groupId = Number(input.filterGroup);
    if (!Number.isNaN(groupId)) params.assigned_group_id = groupId;
  }
  if (input.filterStatus) params.status = input.filterStatus;
  if (input.filterPriority) params.priority = input.filterPriority;
  if (input.searchText) params.search = input.searchText;
  if (input.purchaseRequestId) params.purchase_request_id = input.purchaseRequestId;
  if (input.dateFrom) params.created_from = input.dateFrom;
  if (input.dateTo) params.created_to = input.dateTo;
  return params;
}

export function exportFoundCount(payload: ExportIdListResponse, includeSubtasks = false): number {
  const extra = includeSubtasks ? Number(payload.subtask_count || 0) : 0;
  return Number(payload.total || 0) + extra;
}
